export const STANDARD = 'STANDARD';
export const HOMEMADE_IFRAME = 'HOMEMADE_IFRAME';
export const HOMEMADE_EXTERNAL = 'HOMEMADE_EXTERNAL';
export const HOMEMADE_MODAL = 'HOMEMADE_MODAL';